import Vue from 'vue'
import App from './App.vue'
import VueI18n from 'vue-i18n'
import Language from './language'
import {
	Button,
	Input,
	Checkbox,
	Form,
	FormItem,
	Icon,
	Select,
	Option,
	OptionGroup,
	Loading,
	Drawer
} from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import store from './store'
import router from './router'
import Common from './commons/index.js'
import utils from './utils/index.js'
import './commons/bridge.js'
import * as filters from './filters' // global filters
import './registerServiceWorker'
const defaulHead = require('./assets/default-head.png')
Vue.config.productionTip = false;
Vue.prototype.$store = store;
Vue.prototype.$utils = utils;
Vue.use(Common)
Vue.use(VueI18n)

let locale = 'zh'
if (navigator.language === 'zh') {
	locale = 'zh'
} else if (navigator.language === 'zh-HK' || navigator.language === 'zh-TW') {
	locale = 'zh-h'
} else if (navigator.language.indexOf('en') > -1) {
	locale = 'en'
} else if (navigator.language.indexOf('km') > -1) {
	locale = 'km'
}

let search = location.search.slice(1).split('&')
let searchObj = {}
search.forEach(item => {
	let itemKeyVal = item.split('=')
	searchObj[itemKeyVal[0]] = itemKeyVal[1]
})
if (searchObj.language) {
	switch (searchObj.language) {
		case 'CHINESE':
			locale = 'zh'
			break;
		case 'CHINESETRAD':
			locale = 'zh-h'
			break;
		case 'ENGLISH':
			locale = 'en'
			break;
		case 'CAMBODIA':
			locale = 'km'
			break;
		case 'KH':
			locale = 'km'
			break;
		default:
			locale = 'zh'
			break;
	}
	localStorage.setItem('lang', locale)
	localStorage.setItem('bigLang', searchObj.language)
} else if (localStorage.getItem('lang')) {
	locale = localStorage.getItem('lang')
} else {
	localStorage.setItem('lang', locale)
}

// console.log(666, locale)


if (searchObj.token || searchObj.auth) {
	store.dispatch('auth/updateUserinfo', {
		'token': decodeURIComponent(searchObj.token || searchObj.auth),
		'userId': searchObj.userId || searchObj.username || ''
	});
	// console.log(666,store.state.auth.user)
}

//主题
if (searchObj.theme) {
	store.dispatch('app/setTheme', {
		theme: searchObj.theme
	});
}



const i18n = new VueI18n({
	locale: locale,
	messages: Language
})

Vue.use(Button)
Vue.use(Input)
Vue.use(Checkbox)
Vue.use(Form)
Vue.use(FormItem)
Vue.use(Icon)
Vue.use(Select)
Vue.use(Option)
Vue.use(OptionGroup)
Vue.use(Loading)
Vue.use(Drawer)

var _hmt = _hmt || [];
(function() {
	var hm = document.createElement("script");
	hm.src = "https://hm.baidu.com/hm.js?d9edd16cebc98d25c6b7542f340badec";
	var s = document.getElementsByTagName("script")[0];
	s.parentNode.insertBefore(hm, s);
})();

router.beforeEach((to, from, next) => {
	if (to.meta.disable) {
		return
	} else if (to.meta.title) {
		/*路由发生改变修改页面的title */
		document.title = i18n.t(to.meta.title)
	}

	if (window._hmt) {
		if (to.path) {
			window._hmt.push(['_trackPageview', '/#' + to.fullPath])
		}
	}

	let curnentTimestamp = Date.parse(new Date())
	const metaKeys = Object.keys(to.meta)

	if (metaKeys.indexOf('fromTime') > -1 && metaKeys.indexOf('endTime') > -1) {
		if (curnentTimestamp >= to.meta.fromTime && curnentTimestamp <= to.meta.endTime) {
			next();
		} else {
			router.push('/download')
		}
	} else {
		next();
	}


})

Object.keys(filters).forEach(key => {
	Vue.filter(key, filters[key])
})


// 判断是否为开发环境或需要调试的环境
let locaList = ['test','localhost'];
locaList.forEach((e)=>{
    if(window.location.hostname.indexOf(e) >= 0){
        const VConsole = require('vconsole')
        new VConsole()
    }
})


new Vue({
	router,
	store,
	i18n,
	render: h => h(App)
}).$mount('#app')

export default i18n